/*#__NO_SIDE_EFFECTS__*/
const isEasingArray = (ease) => {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

export { isEasingArray };
//# sourceMappingURL=is-easing-array.mjs.map
